const SvgDataDriven3 = (props) => (
  <>
    <path
      fill={props.p20}
      opacity={0.5}
      d="M64 0h64v64H64zM0 64h64v64H0zM0 192h64v64H0zM0 320h64v64H0zM64 128h64v64H64zM64 256h64v64H64z"
    />
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M112 16h64v64h-64zM48 80h64v64H48zM48 208h64v64H48z"
    />
    <circle cx={176} cy={16} r={4} fill={props.p50} />
    <path fill="none" stroke={props.p50} strokeMiterlimit={10} d="M112 144h64v64h-64zM112 272h64v64h-64z" />
    <circle cx={176} cy={144} r={4} fill={props.p50} />
    <circle cx={112} cy={144} r={4} fill={props.p50} />
    <circle cx={112} cy={80} r={4} fill={props.p50} />
    <circle cx={48} cy={144} r={4} fill={props.p50} />
    <circle cx={48} cy={272} r={4} fill={props.p50} />
    <circle cx={112} cy={208} r={4} fill={props.p50} />
    <circle cx={176} cy={272} r={4} fill={props.p50} />
    <circle cx={112} cy={336} r={4} fill={props.p50} />
    <circle cx={112} cy={272} r={4} fill={props.p50} />
  </>
);

export default SvgDataDriven3;
